
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { MixinsLiveCourse } from '@xt/client/mixins/my/calendar/liveCourse'

@Component({
  components: {}
})
export default class LiveClasshourCard extends Mixins(MixinsLiveCourse) {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
